









































































































































































































import {Component, Watch, Prop} from 'vue-property-decorator';
import GiganautVue from '@/components/Shared/GiganautVue'
import { ReportsModule } from '@/store/modules/reports';
import PayrollReportRequest from '@/models/Reports/PayrollReportRequest';
import DeductionsReportRequest from '@/models/Reports/DeductionsReportRequest';
import TimesheetReportRequest from '@/models/Reports/TimesheetReportRequest';
import NewWorkersReportRequest from '@/models/Reports/NewWorkersReportRequest';
import JobPlacementsReportRequest from '@/models/Reports/JobPlacementsReportRequest';
import NotesReportRequest from '@/models/Reports/NotesReportRequest';
import { AppModule } from '@/store/modules/app';

@Component({
  name: 'DataExportReports', components: {  }
})
export default class extends GiganautVue {

	newWorkerWeekCommencing = '';
	payrollShiftWeekCommencing = '';
	payrollApprovedOnOrAfter = '';
	deductionsShiftWeekCommencing = '';
	deductionsApprovedOnOrAfter = '';
	timesheetShiftWeekCommencing = '';
	timesheetApprovedOnOrAfter = '';
  jobPlacementsWeekCommencing = '';
  notesFrom = '';
  notesTo = '';

	allowedDates(date: Date) {
		return new Date(date).getDay() === 1;
	}

	get loading() {
		return ReportsModule.loading;
	}

  get isAdminUser() {
         return AppModule.userProfile.isAdministrator;
  }

	async downloadMissingPayRollWorkers() {
		if (this.newWorkerWeekCommencing !== "") {
		const request = new NewWorkersReportRequest();
		request.shiftWeekCommencing = this.newWorkerWeekCommencing;
		await ReportsModule.getSageNewWorkers(request);
		}
	}

	async downloadPayroll() {
		if (this.payrollShiftWeekCommencing !== "" && this.payrollApprovedOnOrAfter !== "") {
		const request = new PayrollReportRequest();
		request.shiftWeekCommencing = this.payrollShiftWeekCommencing;
		request.approvedOnOrAfter = this.payrollApprovedOnOrAfter;
		await ReportsModule.getSagePayroll(request);
		}
	}

	async downloadDeductions() {
		if (this.deductionsShiftWeekCommencing !== "" && this.deductionsApprovedOnOrAfter !== "") {
		const request = new DeductionsReportRequest();
		request.shiftWeekCommencing = this.deductionsShiftWeekCommencing;
		request.approvedOnOrAfter = this.deductionsApprovedOnOrAfter;
		await ReportsModule.getSageDeductions(request);
		}
	}

	async downloadTimesheets() {
		if (this.timesheetShiftWeekCommencing !== "" && this.timesheetApprovedOnOrAfter !== "") {
		const request = new TimesheetReportRequest();
		request.shiftWeekCommencing = this.timesheetShiftWeekCommencing;
		request.approvedOnOrAfter = this.timesheetApprovedOnOrAfter;
		await ReportsModule.getTimesheets(request);
		}
	}

  async downloadJobPlacements() {
		if (this.jobPlacementsWeekCommencing !== "") {
		const request = new JobPlacementsReportRequest();
		request.startsWeekCommencing = this.jobPlacementsWeekCommencing;
		await ReportsModule.getJobPlacements(request);
		}
	}

    async downloadNotes() {
		if (this.notesFrom !== "" && this.notesTo !== "") {
		const request = new NotesReportRequest();
		request.from = this.notesFrom;
    request.to = this.notesTo;
		await ReportsModule.getNotes(request);
		}
	}
}
